<script setup lang="ts">
import { Title } from '@/components/ui/title'
import { useCartTotalsStore } from '@/composables/useCartTotalsStore'
import { useCheckoutStore } from '@/composables/useCheckoutStore'
import { router } from '@inertiajs/vue3'
import { ArrowLeftCircle } from 'lucide-vue-next'

const { title, description } = defineProps<{
    title: string
    description?: string
}>()

const { currentStep } = useCheckoutStore()
const cartTotals = useCartTotalsStore()

function handleStep() {
    if (cartTotals.total.value <= 0 || currentStep.value === 2) {
        return router.visit('/cart', {
            preserveScroll: true,
        })
    }

    currentStep.value--
}
</script>

<template>
    <div class="space-y-1">
        <div class="flex gap-2">
            <button @click="handleStep" aria-label="Back" type="button" v-if="currentStep > 1" class="mt-1 cursor-pointer self-start">
                <ArrowLeftCircle stroke-width="1.2" />
            </button>

            <div>
                <Title class="!text-2xl !font-semibold !text-gray-800">{{ title }}</Title>
                <p class="!text-sm !font-normal !text-slate-800" v-if="description">{{ description }}.</p>
            </div>
        </div>
    </div>
</template>
